import React from 'react';


const Footer = () => {
    return (
        <footer
          className="flex items-center justify-center py-3"
          style={{
            borderTop: '1px solid rgba(99,102,241,0.12)',
            background: 'rgba(5,8,16,0.98)',
          }}
        >
          <span className="text-xs" style={{ color: '#334155' }}>
            Developed by{' '}
            <a
              className="text-[#60a5fa] font-semibold no-underline transition-colors duration-300 hover:text-[#93c5fd]"
              href="https://harpiai.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              HarpiAI
            </a>
          </span>
        </footer>
    );
};

export default Footer;
